import { useEffect, useState } from 'react'
import { useModalBox } from '../../contexts'
import {
  SelectsForConstructorModel,
  BlockApplicationModel
} from '../../../domain/models'
import { fetchSelectsForConstructor } from '../../../main/usecases'

import { dateToday, getUser } from '../../utils'
import { Input, SelectInput, Textarea, Checkbox, Button } from '..'

import { IconTrashSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'
import ClippingIcon from '../../assets/icons/svgComponents/clipping-icon'
import ImportFileModalFactory from '../../../main/factories/import-file-modal'
import { useAlert } from 'react-alert'
import { fetchUploads, saveBlock } from '../../../main/usecases/Import-files'

type TestCardProps = {
  constructor: BlockApplicationModel
  onRemove: any
  match: any
  dispatch: any
  disable: boolean
  setDisable: (param: boolean) => void
  cdAplicacao: number
}

const TestCard = ({
  constructor,
  onRemove,
  match,
  dispatch,
  disable,
  setDisable,
  cdAplicacao
}: TestCardProps) => {
  const alert = useAlert()
  const { modalBox } = useModalBox()
  const [data, setData] = useState<BlockApplicationModel>({
    ...constructor,
    resultadoTeste: { ...constructor.resultadoTeste }
  })
  const [selectsForConstructor, setSelectsForConstructor] = useState<
    SelectsForConstructorModel[]
  >([])
  const [results, setResults] = useState([
    {
      value: data?.resultadoTeste?.resultado || '',
      label: data?.resultadoTeste?.resultado || ''
    }
  ])
  const [loading, setLoading] = useState(false)

  const user = getUser()
  useEffect(() => {
    ;(async () => {
      try {
        setLoading(true)
        const responseSelectsForConstructor = await fetchSelectsForConstructor({
          idConstructo: constructor.construto.cdConstruto,
          idService: match?.params?.idassessment
        }).load()
        setSelectsForConstructor(responseSelectsForConstructor)
        setLoading(false)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [constructor.construto.cdConstruto, match?.params?.idassessment])

  const handleMenuFocus = () => {
    setResults(
      selectsForConstructor
        ?.find((item) => item?.cdTeste === data?.resultadoTeste?.teste?.cdTeste)
        ?.classificacao?.map((el) => {
          return { label: el, value: el }
        }) || [{ label: '', value: '' }]
    )
  }

  useEffect(() => {
    dispatch({
      type: 'updateCard',
      data: data
    })
  }, [dispatch, data])
  const handleImportClick = async () => {
    setDisable(true)
    const body = {
      ...(data.cdBlocoAplicacaoTeste && {
        cdBlocoAplicacaoTeste: data.cdBlocoAplicacaoTeste
      }),
      construto: {
        cdConstruto: data?.construto?.cdConstruto,
        categoriaConstruto: data?.construto?.categoriaConstruto,
        construto: data?.construto?.construto
      },
      resultadoTeste: {
        construto: data?.construto?.cdConstruto,
        customTeste: data?.resultadoTeste?.customTeste,
        teste: data?.resultadoTeste?.teste?.cdTeste
          ? {
              cdTeste: data?.resultadoTeste?.teste?.cdTeste
            }
          : undefined,
        incluirBloco: data?.resultadoTeste?.customTeste
          ? false
          : data?.resultadoTeste?.incluirBloco,
        numeroPontos: data?.resultadoTeste?.numeroPontos,
        percentil: data?.resultadoTeste?.percentil,
        resultado: data?.resultadoTeste?.resultado,
        observacao: data?.resultadoTeste?.observacao,
        data: data?.resultadoTeste?.data
          ? data?.resultadoTeste?.data
          : dateToday
      }
    }
    try {
      const response = await saveBlock(cdAplicacao).post(body)
      alert.show('Salvo', {
        type: 'success',
        timeout: 4000
      })
      setDisable(false)
      const uploads = await fetchUploads(response.cdBlocoAplicacaoTeste).load()
      setData((prev: any) => ({
        position: prev.position,
        ...response
      }))

      modalBox(
        <ImportFileModalFactory
          uploads={uploads}
          cdBloco={response.cdBlocoAplicacaoTeste}
          cdPsicologo={user.cdPsicologo}
        />,
        'Anexar arquivos e fotos'
      )
    } catch (error) {
      console.error(error)
      alert.show('Erro ao salvar o Teste', {
        type: 'error',
        timeout: 4000
      })
    }
  }
  return (
    <>
      {!loading && (
        <S.Wrapper>
          <S.CardHeader>
            <p>{constructor?.construto?.construto}</p>
            <button onClick={onRemove}>
              <IconTrashSvg />
            </button>
          </S.CardHeader>
          <S.CardBody>
            <Checkbox
              label="Incluir na análise"
              isChecked={data?.resultadoTeste?.incluirBloco || true}
              wrapperClassName="checkbox"
              onClick={() => {
                setData((prev: any) => ({
                  ...prev,
                  resultadoTeste: {
                    ...prev.resultadoTeste,
                    incluirBloco: !data.resultadoTeste.incluirBloco
                  }
                }))
              }}
            />
            <SelectInput
              label="Nome*"
              hasTestSelectInput
              labelColor="#4F4F4F"
              name="name"
              onChange={(e: any) =>
                setData((prev: any) => ({
                  ...prev,
                  resultadoTeste: {
                    ...prev.resultadoTeste,
                    teste: { cdTeste: Number(e.target.value) }
                  }
                }))
              }
              value={data?.resultadoTeste?.teste?.cdTeste}
              defaultValue={data?.resultadoTeste?.teste?.cdTeste}
              options={selectsForConstructor?.map(
                (item: SelectsForConstructorModel) => {
                  return { value: item?.cdTeste, label: item.nome }
                }
              )}
            />
            <Input
              labelColor="#4F4F4F"
              hasTestInput
              label="Número de pontos"
              name="numeroPontos"
              type="number"
              onChange={(e: any) =>
                setData((prev: any) => ({
                  ...prev,
                  resultadoTeste: {
                    ...prev.resultadoTeste,
                    numeroPontos: e.target.value
                  }
                }))
              }
              value={data?.resultadoTeste?.numeroPontos}
            />
            <Input
              hasTestInput
              labelColor="#4F4F4F"
              label="Percentil"
              name="percentil"
              type="number"
              min={0}
              step="0.01"
              pattern=""
              onChange={(e: any) =>
                setData((prev: any) => ({
                  ...prev,
                  resultadoTeste: {
                    ...prev.resultadoTeste,
                    percentil: e.target.value
                  }
                }))
              }
              value={data?.resultadoTeste?.percentil}
            />
            <SelectInput
              onFocus={() => handleMenuFocus()}
              label="Resultado"
              hasTestSelectInput
              hasSelectOption={false}
              labelColor="#4F4F4F"
              name="result"
              onChange={(e: any) =>
                setData((prev: any) => ({
                  ...prev,
                  resultadoTeste: {
                    ...prev.resultadoTeste,
                    resultado: e.target.value
                  }
                }))
              }
              value={data?.resultadoTeste?.resultado}
              defaultValue={data?.resultadoTeste?.resultado}
              options={results}
            />
            <Input
              hasTestInput
              labelColor="#4F4F4F"
              label="Data"
              name="date"
              type="date"
              max={'2222-10-29'}
              onChange={(e: any) =>
                setData((prev: any) => ({
                  ...prev,
                  resultadoTeste: {
                    ...prev.resultadoTeste,
                    data: e.target.value
                  }
                }))
              }
              value={data?.resultadoTeste?.data || dateToday}
            />
            <Textarea
              hasTestTextarea
              labelColor="#4F4F4F"
              label="Obs:"
              name="observation"
              placeholder="Descrição da observação"
              className="textarea"
              onChange={(e: any) =>
                setData((prev: any) => ({
                  ...prev,
                  resultadoTeste: {
                    ...prev.resultadoTeste,
                    observacao: e.target.value
                  }
                }))
              }
              value={data?.resultadoTeste?.observacao}
            />
            <div className="import-files">
              Anexar arquivos
              <Button disabled={disable} onClick={() => handleImportClick()}>
                <ClippingIcon />
              </Button>
            </div>
          </S.CardBody>
        </S.Wrapper>
      )}
    </>
  )
}

export default TestCard
